// footerData.ts
export const footerData = {
  sections: [
    {
      title: "CONTACT",
      links: [
        { label: "Email :", url: "" },
        { label: "Phone :6280450509", url: "" },
        { label: "Address: 11no 4th crossing Abohar (152116) " }
      ]
    },

    {
      title: "Categories",
      links: [
        { label: "Titan", url: "/" },
        { label: "Sonata", url: "/" },
        { label: "Fastrack", url: "/" },
        { label: "Logues", url: "/" },
        { label: "Tommy", url: "/" },
        { label: "Police", url: "/" },

      ]
    },
    {
      title: "POLICIES",
      links: [
        { label: "Terms & Conditions", url: "/terms" },
        { label: "No Exchange & Return", url: "/no-exchange-return" },
        { label: "Privacy Policy", url: "/privacy-policy" },
        { label: "Shipping & Delivery", url: "/shipping-delivery" },
        { label: "Shipping Policy", url: "/shipping-policy" },
        { label: "Cancellation Policy", url: "/cancellation-policy" },
        { label: "Privacy Policy", url: "/privacy-policy" },
        { label: "Contact", url: "/contact" },
      ]
    },

  ],
  social: [
    { platform: "Facebook", icon: "bi bi-facebook", url: "https://facebook.com" },
    { platform: "Twitter", icon: "bi bi-twitter-x", url: "https://twitter.com" },
    { platform: "Instagram", icon: "bi bi-instagram", url: "https://www.instagram.com/sardar_times94" },
    { platform: "YouTube", icon: "bi bi-youtube", url: "https://youtube.com" }
  ],
  legal: [
    { label: "Terms & Conditions", url: "/terms" },
    { label: "Shipping Policy", url: "/shipping-policy" },
    { label: "Cancellation Policy", url: "/cancellation-policy" },
    { label: "Privacy Policy", url: "/privacy-policy" }
  ],
  copyright: "© 2026 Sardar Times94 E-RETAIL LIMITED All Rights Reserved."
};
